import { useSelector } from 'react-redux';
import { getCustomLayers, getLayersAttributes } from './index';

export const useLayersAttributes = () => useSelector(getLayersAttributes);
export const useCustomLayers = () => useSelector(getCustomLayers);
